import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import Text from "components/common/Text";
import { GridSearchIcon } from "@mui/x-data-grid";
import IconButton from "components/common/IconButton";
import Box from "components/common/Box";
import CloseIcon from "@mui/icons-material/Close";

const useStyles = makeStyles({
  dropdown: {
    position: "relative",
    display: "inline-block",
    paddingLeft: "30px",
  },
  dropdownButton: {
    padding: "10px",
    fontSize: "16px",
    cursor: "pointer",
  },
  dropdownContent: {
    display: "none",
    position: "absolute",
    backgroundColor: "#f9f9f9",
    minWidth: "160px",
    boxShadow: "0px 8px 16px 0px rgba(0,0,0,0.2)",
    padding: "12px 16px",
    zIndex: 1,
  },
  showDropdown: {
    display: "block",
  },
  checkboxGroup: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  checkboxLabel: {
    margin: "5px 0",
  },
  showMoreLink: {
    marginTop: "10px",
    cursor: "pointer",
    color: "blue",
  },
  searchbar: {
    left: "20px",
    width: "200px",
    display: "flex",
    alignItems: "center",
    border: "#eaeaea",
    position: "absolute",
    right: "30px",
    borderRadius: "20px",
    padding: "5px 10px",
    backgroundColor: "#eaeaea",
  },
  actionButtons: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "10px",
  },
  actionButton: {
    padding: "5px 10px",
    cursor: "pointer",
    backgroundColor: "#007bff",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    margin: "0 5px",
  },
  clearButton: {
    backgroundColor: "#dc3545",
  },
  CloseIcon: {
    position: "absolute",
    top: "10px",
    right: "20px",
    fontSize: "25px",
  },
  CloseIconbutton: {
    position: "relative",
    top: "5px",
    right: "5px",
  },
  searchcloseicon: {
    display: "flex",
    justifyContent: "space-between",
  },
});

const Filter = ({
  data,
  searchkey,
  filterType,
  filterData,
  setFilterData,
  clearfilter,
  dataType,
}) => {
  const classes = useStyles();
  const [showMore, setShowMore] = useState(false);
  const [searchActive, setSearchActive] = useState(false);
  const [searchKey, setSearchKey] = useState("");
  const names = filterData[dataType]?.map((item) => item.name);
  const [brandData, setBrandData] = useState(
    data.map((brand, index) => ({
      id: index,
      name: brand,
      selected: names?.includes(brand) ? true : false,
    }))
  );

  const handleCheckboxChange = (e) => {
    const updatedBrandData = brandData.map((item) =>
      item.name === e.target.name ? { ...item, selected: !item.selected } : item
    );
    setBrandData(updatedBrandData);
  };

  const toggleShowMore = () => {
    setShowMore(!showMore);
  };

  const toggleSearch = () => {
    setSearchActive(!searchActive);
    setSearchKey("");
  };

  const handleSearchChange = (event) => {
    setSearchKey(event.target.value);
  };

  const filteredBrands = brandData.filter((brand) =>
    brand?.name?.toLowerCase().includes(searchKey.toLowerCase())
  );

  const initialDisplayCount = 5;

  useEffect(() => {
    const selectedBrands = brandData.filter((brand) => brand.selected);
    setFilterData({ ...filterData, selectedBrands });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [brandData, setFilterData]);

  return (
    <div className={classes.dropdown}>
      <Box className={classes.searchcloseicon}>
        <Text style={{ marginTop: "15px" }}>{filterType}</Text>
        {searchkey &&
          (searchActive ? (
            <Box>
              <input
                style={{ marginTop: "10px" }}
                value={searchKey}
                onChange={handleSearchChange}
                className={classes.searchbar}
                type="text"
                placeholder="Search trend"
              />
              <CloseIcon className={classes.CloseIcon} onClick={toggleSearch} />
            </Box>
          ) : (
            <IconButton
              className={classes.CloseIconbutton}
              type="submit"
              aria-label="search"
              onClick={toggleSearch}
            >
              <GridSearchIcon style={{ fontSize: "25px" }} />
            </IconButton>
          ))}
      </Box>
      <div className={classes.checkboxGroup}>
        {(showMore
          ? filteredBrands
          : filteredBrands.slice(0, initialDisplayCount)
        )?.sort((a, b) => a.name.localeCompare(b.name))
        .map((brand) => (
          <label key={brand.id} className={classes.checkboxLabel}>
            <input
              type="checkbox"
              checked={brand.selected}
              onChange={handleCheckboxChange}
              name={brand.name}
            />
            {brand.name}
          </label>
        ))}
        {data.length > initialDisplayCount && (
          <span className={classes.showMoreLink} onClick={toggleShowMore}>
            {showMore ? "less" : `+${data.length - initialDisplayCount} more`}
          </span>
        )}
      </div>
    </div>
  );
};

Filter.propTypes = {
  data: PropTypes.arrayOf(PropTypes.string).isRequired,
  searchkey: PropTypes.bool.isRequired,
  filterType: PropTypes.string.isRequired,
  setFilterData: PropTypes.func.isRequired,
  clearfilter: PropTypes.bool.isRequired,
};

export default Filter;
